import { ERP } from '../_base/endpoint';
import axios from 'axios';

class tipoPlanContable {
    
    /******* QUERIES ******/

    async listar() {
        const response = await axios
            .get(`${ERP}administracion/tipo-plan-contable`)
            .then(response => { 
                return response.data; 
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };
}

export default new tipoPlanContable();